export default __webpack_public_path__ + "static/media/job-switching-arrow-left-gray.8029ddfe.svg";